import { render, staticRenderFns } from "./TenantExpired.vue?vue&type=template&id=4d782030&scoped=true"
import script from "./TenantExpired.vue?vue&type=script&lang=js"
export * from "./TenantExpired.vue?vue&type=script&lang=js"
import style0 from "./TenantExpired.vue?vue&type=style&index=0&id=4d782030&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d782030",
  null
  
)

export default component.exports